import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Outlet, Link, Navigate } from 'react-router';
import '../../assets/scss/broox.scss';
import { IServiceFactory } from '../../services/IServiceFactory';
import { Instances } from './Instances';
import { refresh, toggleMenu } from '../../services/UiService';
import { Nodes } from './Nodes';
import { AuthProvider, useAuth } from '../../contexts/AuthContext';
import { Login } from '../Login';

const App = ({ serviceFactory }: Props) => {
  useEffect(() => {
    setTimeout(() => {
      refresh();
    }, 5000);
  }, []);

  const onToggleMenu = () => {
    toggleMenu();
  }

  const Layout = () => {
    const onLogout = async () => {
      await serviceFactory.getAuthService().logout();
    }

    const user = useAuth();
    if(user) {
      return (
        <div className="layout-wrapper layout-content-navbar">
          <div className="layout-container">
            <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
              <div className="app-brand mt-4">
                <Link to={'/'} className="app-brand-link">
                  <span className="app-brand-logo">
                    <div className="logo"></div>
                  </span>
                </Link>
                <a className="layout-menu-toggle menu-link text-large ms-auto" onClick={onToggleMenu}>
                  <i className="ti menu-toggle-icon ti-sm align-middle"></i>
                </a>
              </div>
              <div className="menu-inner-shadow"></div>
              <ul className="menu-inner py-1">
                <li className="menu-item">
                  <Link to={'/instances'} className="menu-link">
                    <i className="menu-icon tf-icons ti ti-layout-list"></i>
                    <div>Studio Instances</div>
                  </Link>
                </li>
                <li className="menu-item">
                  <Link to={'/nodes'} className="menu-link">
                    <i className="menu-icon tf-icons ti ti-sitemap"></i>
                    <div>Nodes</div>
                  </Link>
                </li>
                <li className="menu-header small text-uppercase">
                  <span className="menu-header-text">USER</span>
                </li>
                <li className="menu-item">
                  <a className="menu-link" onClick={onLogout}>
                    <i className="menu-icon tf-icons ti ti-logout"></i>
                    <div>Logout</div>
                  </a>
                </li>
              </ul>
            </aside>
            <div className="layout-page">
              <div className="content-wrapper">
                <div className="container-xxl d-flex align-items-stretch flex-grow-1 p-0">
                  <div className="flex-shrink-1 flex-grow-1 container-p-x container-p-y">
                    <Outlet />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    else {
      return (
       <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname.replace('/admin', ''))}`} />
      );
    }
  }

  return (
    <BrowserRouter basename="/admin">
      <AuthProvider authService={serviceFactory.getAuthService()}>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Nodes serviceFactory={serviceFactory} />} />
            <Route path="/instances" element={<Instances serviceFactory={serviceFactory} />} />
            <Route path="/nodes" element={<Nodes serviceFactory={serviceFactory} />} />
          </Route>
          <Route path="/login" element={<Login authService={serviceFactory.getAuthService()} />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

interface Props {
  serviceFactory: IServiceFactory
}

export { App };
